export const environment = {
  production: true,
  clientId: 'rsmu-client',
  secret: '9xjMq3LpqZNsYqZNiGLx',
  apiUrl: 'https://paracelsus.rsmu.ru/oep',
  idpUrl: 'https://paracelsus.rsmu.ru/sso',
  loginUrl: 'https://paracelsus.rsmu.ru/sso/idp/login.html',
  idpTicketParam: '#idp_ticket',
  rnimuQuizConfig: {
    url: 'https://paracelsus.rsmu.ru/qt-portal/rest',
    escapeTabTimes: 2
  },
  iszUrl: 'https://paracelsus.rsmu.ru/isz/api/rest/front',
  authStorageKey: 'paracelsusTokenData',
  style: 'paracelsus'
};
